<template>
  <div class="main">
    <div class="contetn">
      <div class="item">
        <h1><span>STEP 1</span>患者申请单</h1>
        <div><p class="p"><b>基本信息：</b><span>患者</span><span>{{detailInfo.patGender}}</span> <span>{{detailInfo.patAge}}</span></p></div>
        <div><p class="p long"><b>检查部位：</b><span>{{detailInfo.checkPoint}}</span></p></div>
        <div><p class="p long"><b>临床诊断：</b><span>{{detailInfo.clinic}}</span></p></div>
        <div><p class="p long"><b>检查目的：</b><span>{{detailInfo.studyDest}}</span></p></div>
        <div><p class="p long"><b>病例摘要：</b><span>{{detailInfo.clinicDiagnosis}}</span></p></div>
      </div>
      <div class="border"></div>
      <div class="item">
        <h1 style="display: flex;align-items: center;">
          <span>STEP 2</span>影像资料
          <!-- <span v-for="val in detailInfo.studyUploadList" :key="val.studyUuid" style="margin-left:8px;display: flex;align-items: center;">
            {{val.accessNo}}
            <button class="btn" @click="getdimage(val.url)">查看影像</button>
          </span> -->
        </h1>
        <ul class="jc-list">
          <!-- <li v-for="val in 20" :key="val" @click="getdimage(val.url)"> -->
          <li v-for="val in detailInfo.studyUploadList" :key="val.studyUuid" @click="getdimage(val.url)">
            <div>
              <h2><img src="../../../assets/images/yx.png" class="account" alt />检查编号</h2>
              <p>{{val.accessNo}}</p>
            </div>
            <div><i class="el-icon-arrow-right" style="color:rgba(0, 0, 0, 0.4);font-weight:600"></i></div>
          </li>
        </ul>
      </div>
      <div class="border" style="margin-top:32px"></div>
      <div class="item">
        <h1><span>STEP 3</span>报告详情单</h1>
        <div><p class="p"><b>检查类型：</b><span>{{detailInfo.modality}}</span></p></div>
        <div><p class="p"><b>检查项目：</b><span>{{detailInfo.examItem}}</span></p></div>
        <div>
          <p class="p" style="margin-top:16px">
            <b>影像学表现：</b>
            <img @click="isopenV1" class="eye" :src="require(`../../../assets/images/${iseyeopenV1?'eye-open.png':'eye-close.png'}`)" alt="">
            <!-- <img src="../../../assets/images/eye-open.png" class="account" alt /> -->
          </p>
          <span>{{iseyeopenV1?detailInfo.finding:'*'.repeat(detailInfo.finding?detailInfo.finding.length:0)}}</span>
        </div>
        <div>
          <p class="p" style="margin-top:16px">
            <b>诊断：</b>
            <!-- <img src="../../../assets/images/eye-open.png" class="account" alt /> -->
            <img @click="isopenV2" class="eye" :src="require(`../../../assets/images/${iseyeopenV2?'eye-open':'eye-close'}.png`)" alt="">
          </p>
          <span>{{iseyeopenV2?detailInfo.conclusion:'*'.repeat(detailInfo.conclusion?detailInfo.conclusion.length:0)}}</span>
        </div>
      </div>
      <div class="border"></div>
      <div class="item">
        <h1><span>STEP 4</span>病理报告</h1>
        <div>
          <p class="p" style="margin-top:16px">
            <b>病理诊断：</b>
            <img @click="isopenV3" class="eye" :src="require(`../../../assets/images/${iseyeopenV3?'eye-open':'eye-close'}.png`)" alt="">
          </p>
          <span>{{iseyeopenV3?detailInfo.caseDiagnosis:'*'.repeat(detailInfo.caseDiagnosis?detailInfo.caseDiagnosis.length:0)}}</span>
        </div>
        <div>
          <p class="p" style="margin-top:16px">
            <b>病理解析：</b>
            <img @click="isopenV4" class="eye" :src="require(`../../../assets/images/${iseyeopenV4?'eye-open':'eye-close'}.png`)" alt="">
          </p>
          <span>{{iseyeopenV4?detailInfo.caseAnalysis:'*'.repeat(detailInfo.caseAnalysis?detailInfo.caseAnalysis.length:0)}}</span>
        </div>
        <div style="overflow: hidden;margin-top: 10px;">
          <div class="p long">
            <div class="con-img" v-for="(v, index) in contentImage" :key="v.key" @click="openImageBox(contentImage,index)">
              <img :src="v.fileUrl" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>
    <image-box ref="imageBox" style="z-index:3000"></image-box>
  </div>
</template>

<script>
import imageBox from '@/components/imageBox';
import { caseServer } from '@/api/api'
export default {
  components: {imageBox},
  data () {
    return {
      detailInfo: {},
      iseyeopenV1: false,
      iseyeopenV2: false,
      iseyeopenV3: false,
      iseyeopenV4: false,
      contentImage: []
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    // 报告详情
    getDetail () {
      caseServer.caseDetail({
        // studyId: '67e28d759e0f47319bae635b7946d33a'
        studyId: this.$route.query.studyId
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.detailInfo = data
          this.getfileurl(data.caseImgs, 'contentImage');
        } else {
          this.$message.error(message)
        }
      })
    },
    // 查看影像
    getdimage (url) {
      window.open(this.$dimage + url, '_blank')
    },
    isopenV1 () {
      this.iseyeopenV1 = !this.iseyeopenV1
    },
    isopenV2 () {
      this.iseyeopenV2 = !this.iseyeopenV2
    },
    isopenV3 () {
      this.iseyeopenV3 = !this.iseyeopenV3
    },
    isopenV4 () {
      this.iseyeopenV4 = !this.iseyeopenV4
    },
    getfileurl (fileKeys, prop) {
      if (!fileKeys) {
        return
      }
      if (fileKeys.length) {
        if (Array.isArray(fileKeys)) {
          this[prop] = fileKeys.map(v => { return {...v, key: v.key}})
        } else {
          this[prop] = fileKeys.split(',').map(v => { return {key: v}})
        }
        this.$getUrl({
          fileKeys: Array.isArray(fileKeys) ? fileKeys.map(v => v.key).join() : fileKeys
        }).then(obj => {
          if (obj) {
            this[prop].forEach((e) => {
              if (e) {
                this.$set(e, 'fileUrl', obj[e.key] || '')
              }
            })
          }
        })
      }
    },
    openImageBox (list, index) {
      if (this.$refs.imageBox) {
        let imageList = []
        if (list.fileUrl) {
          imageList.push({ url: `${list.fileUrl}` })
        } else {
          for (let i = 0, length = list.length; i < length; i++) {
            imageList.push({ url: `${list[i].fileUrl}` })
          }
        }
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: list.fileUrl ? 0 : index // 问题区图片只有一张 下标传0
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  background: linear-gradient(243deg, rgba(49, 142, 255, 0.29) 50%, rgba(216, 216, 216, 0) 100%);
  width: 100%;
  height: 100vh;
  padding: 24px 32px;
  .contetn {
    width: 100%;
    height: 100%;
    overflow: auto;
    text-align: left;
    border-radius: 8px;background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    box-shadow: 0px 7px 10px -6px rgba(158, 188, 225, 0.3),inset 1px 1px 7px 0px #D4E5F6;
    padding: 48px 32px;
    .item {
      line-height: 24px;
      font-size: 16px;
    }
    h1 {
      font-family: PangMenZhengDao;
      font-weight: normal;
      color: rgba(0, 0, 0, 0.9);
      font-size: 26px;
      margin-bottom: 16px;
      span {
        font-family: YouSheBiaoTiHei;
        font-size: 30px;
        color: #3176FF;
        margin-right: 16px;
      }
      .btn {
        width: 88px;
        height: 32px;
        border-radius: 16px;
        border: 1px solid #3176FF;
        background: #3176FF;
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 16px;
      }
    }
    .p {
      margin-bottom: 8px;
      color: #3D3D3D;
      .eye {
        width: 24px;
        height: 24px;
        vertical-align: bottom;
        cursor: pointer;
      }
    }
    .border {
      width: 100%;
      height: 1px;
      background: #E7E7E7;
      margin-top: 8px;
      margin-bottom: 33px;
    }
    .jc-list {
      display: flex;
      gap: 16px 24px;
      flex-wrap: wrap;
      margin-top: 32px;
      li {
        width: 240px;
        height: 78px;
        padding: 10px 24px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 16px;
        border: 2px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        h2 {
          margin-bottom: 4px;
          font-size: 16px;
          color: #3D3D3D;
          img {
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin-right: 8px;
          }
        }
        p {
          color: #3D3D3D;
        }
      }
    }
    .con-img {
      width: 148px;
      height: 148px;
      float: left;
      margin-right: 10px;
      margin-bottom: 25px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/resource/details/caseDataPage.vue